/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { View, StyleSheet, Platform, Dimensions } from "react-native";
import LhButton from "../../../components/LhButton";
import LHOverlay from "../../../components/LHOverlay";
import { useTheme } from "../../../theme";

interface NHOBeginProps {
  isModalVisible: boolean;
  closeModal: () => void;
  renderDropdowns: () => React.ReactNode;
  handleSaveFilters: () => void;
  filters?: {
    employee: string;
    observationType: string;
  };
}
const isIPad = Platform.OS === "ios" && Dimensions.get("window").width >= 768;
const NHOBegin: React.FC<NHOBeginProps> = ({
  isModalVisible,
  closeModal,
  renderDropdowns,
  handleSaveFilters,
  filters = { employee: "", observationType: "" },
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDarkTheme = resolvedTheme === "dark";
  // Function to handle the Begin button click
  const handleBeginClick = () => {
    // Let the parent component handle validation and navigation
    handleSaveFilters();
  };
  return (
    <LHOverlay
      visible={isModalVisible}
      onDismiss={closeModal}
      title="Select New Hire Onboarding Options"
      size="small"
      position="center"
    >
      <View
        style={[
          styles.modalContainer,
          isDarkTheme && { backgroundColor: colors.background.surface },
        ]}
      >
        {renderDropdowns()}

        <View style={styles.modalButtons}>
          <LhButton
            text="Cancel"
            variant="secondary"
            size="small"
            onPress={closeModal}
            isLoading={false}
            disabled={false}
            style={styles.modalButton}
          />
          <LhButton
            text="Proceed"
            variant="primary"
            size="small"
            onPress={handleBeginClick}
            isLoading={false}
            disabled={false}
            style={styles.modalButton}
          />
        </View>
      </View>
    </LHOverlay>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    padding: 16,
    backgroundColor: 'white',
  },
  modalButtons: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 20,
    gap: 10,
  },
  modalButton: {
    width: Platform.OS === "web" || isIPad ? "25%" : "40%",
    fontSize: 16,
    borderWidth:0
  },
});

export default NHOBegin;
